export default {
      id: "oc-icon_ram-usage",
      viewBox: "0 0 150 150",
      url: __webpack_public_path__ + "sprite.svg#oc-icon_ram",
      toString: function () {
        return this.url;
      }
    }